import { render, staticRenderFns } from "./BundleListing.vue?vue&type=template&id=58c24201&"
import script from "./BundleListing.vue?vue&type=script&lang=js&"
export * from "./BundleListing.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports